import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message, notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import { CreateTaskRequest } from '@/components/ui/Inputs/types/request/task';
import Api from '@/services/api';

export const useCreateTLID = () => {
	const queryClient = useQueryClient();
	return useMutation(({ body }: { body: CreateTaskRequest }) => Api.post('/task/create', body), {
		onError: (err: any) => {
			notification.error({
				message: I18n.get(err?.response?.data?.message || 'Ops... something happened!')
			});
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries(['tasks']);
			message.success(I18n.get('Task created successfully'));
		}
	});
};
